import React from "react";
import { connect } from "react-redux";
import api from "../../../config/api.js";
import config from "../../../config/app.js";
import { insertToast, setModal } from "../../actions";
import * as types from "../../constants/ActionTypes";

@connect((store) => {
  return {
    modal: store.modal,
    User: store.User,
  };
})
class UserEmailConfirm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      email: this.props.User.User.email_communication,
    };
  }

  handleSubmit(e) {
    e.preventDefault();
    api
      .post(`/users/${this.props.User.User.uid}/email`, {
        email: this.state.email,
      })
      .then((res) => {
        this.props.dispatch(
          insertToast({
            title: "Success",
            body: "Your email has been updated",
          })
        );
        console.log(res);
        console.log(res.data);
        // var data = {
        //   user: res.data
        // };
        this.props.dispatch({
          type: types.SET_USER,
          user: res.data,
        });
        this.props.dispatch(setModal());
      })
      .catch((e) => {
        console.log("Error adding assessment at server", e);
      });
  }

  handleItemChange(e) {
    this.setState({ email: e.target.value });
    console.log(this.state.email);
  }

  closeModal() {
    this.props.dispatch(setModal());
  }

  render() {
    return (
      <div id="emialProfileConfirmation" className={"modal-fill"}>
        <div className="modal-header">
          <div className="modal-title fill">
            <b>Profile Confirmation</b>
          </div>
          <div className="close link" onClick={(e) => this.closeModal(e)}>
            X
          </div>
        </div>
        <div className="modal-content">
          <p>
            Please provide a valid email address to be used for all
            communications from Special T.
          </p>
          <form action="">
            <input
              type="email"
              placeholder="Contact Email"
              onChange={(e) => this.handleItemChange(e, "name")}
              value={this.state.email}
            />
            <button
              onClick={(e) => this.handleSubmit(e)}
              type="submit"
              name=""
              id=""
            >
              Submit
            </button>
          </form>
        </div>
      </div>
    );
  }
}
export default UserEmailConfirm;



// WEBPACK FOOTER //
// ./src/components/user/UserEmailConfirm.jsx